<template>
  <div>
    <v-icon @click="setDialog(true)">
      {{ icons.mdiPalette }}
    </v-icon>
  </div>
</template>

<script>
import { mdiPalette } from '@mdi/js'
import { mapMutations } from 'vuex'

// import useAppConfig from '@core/@app-config/useAppConfig'

export default {
  data() {
    return {
      dialog: false,
      icons: {
        mdiPalette,
      },
    }
  },
  methods: {
    ...mapMutations('appConfig', ['setDialog']),
  },
}
</script>

<style lang="scss">

</style>
